<template>
  <div class="hortense-travel">
    <div class="container">
      <!-- Header Section -->
      <div class="header-section">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class="mb-0 text-center">Voyagez autrement</p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">avec Hortense</p>
      </div>

      <!-- Introduction Section -->
      <div class="intro-section">
        <p class="intro-text raleway-reg-p15">
          Chez Hortense, les destinations ne sont jamais choisies au hasard. Chacune d'entre elles incarne une certaine idée du voyage : plus lent, plus élégant, plus conscient. Derrière chaque lieu sélectionné, il y a une histoire, une atmosphère, une promesse d'évasion durable. Que ce soit en France ou ailleurs dans le monde, nous vous proposons des destinations soigneusement sélectionnées pour leur authenticité, leur charme et leur engagement.
        </p>
      </div>

      <!-- Selection Philosophy Section -->
      <div class="philosophy-section" v-if="!isPhone || (isPhone && expanded)">
        <h2 class="section-title raleway-bold-p15">Notre sélection de destinations : l'art du choix</h2>
        <p class="philosophy-text raleway-reg-p15" v-if="!expanded">
          Nous croyons qu'un voyage réussi commence par une sélection exigeante. C'est pourquoi nous parcourons les régions, les pays et les continents pour ne retenir que des destinations qui partagent notre vision : celle d'un tourisme respectueux, local, et inspirant. Des plages méditerranéennes aux sommets alpins, des villages de caractère
        </p>
        <p class="philosophy-text raleway-reg-p15" v-if="expanded">
           Nous croyons qu'un voyage réussi commence par une sélection exigeante. C'est pourquoi nous parcourons les régions, les pays et les continents pour ne retenir que des destinations qui partagent notre vision : celle d'un tourisme respectueux, local, et inspirant. Des plages méditerranéennes aux sommets alpins, des villages de caractère aux cités vibrantes, nos destinations sont aussi diverses que cohérentes. Chaque lieu est intégré à notre collection avec soin, selon des critères précis d'accueil, de cadre naturel, de patrimoine et de bien-être.
        </p>
      </div>

      <!-- Call to Action -->
      <div class="cta-section">
        <button class="show-more-btn raleway-semi-p16" @click="toggleShowMore">{{ expanded ? 'Afficher moins' : 'Afficher plus' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HortenseTravel',
  data() {
    return {
      expanded: false,
      isPhone: window.innerWidth <= 768
    };
  },
  methods: {
    toggleShowMore() {
      this.expanded = !this.expanded;
    },
    openMapModal() {
      this.$root.$emit('openMapModal');
    }
  }
};
</script>

<style scoped>
.hortense-travel {
  padding: 60px 20px;
  position: relative;
}

.container {
  max-width: 90%;
  margin: 0 auto;
}

/* Header Section */
.header-section {
  text-align: center;
  margin-bottom: 50px;
}

/* Introduction Section */
.intro-section {
  margin-bottom: 50px;
}

.intro-text {
  line-height: 1.8;
  margin: 0;
  text-align: justify;
}

/* Philosophy Section */
.philosophy-section {
  margin-bottom: 40px;
}

.section-title {
  margin: 0 0 20px 0;
  letter-spacing: -0.3px;
}

.philosophy-text {
  line-height: 1.8;
  margin: 0;
  text-align: justify;
}

/* CTA Section */
.cta-section {
  margin-top: 40px;
}

.show-more-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  transition: opacity 0.3s ease;
}

.show-more-btn:hover {
  opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hortense-travel {
    padding: 40px 16px;
  }

  .header-section {
    margin-bottom: 15px;
  }
}
</style>
